import ChessRestClient from '@/Api/ChessRestClient';
import {useMutation} from '@tanstack/react-query';

export type ResumeCsocSubscriptionPayload = {
  order_id: string;
  resume_date?: string; // dd/mm/yyyy (optional, defaults to today)
};

export default function useResumeCsocSubscription(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation({
    mutationFn: async (payload: ResumeCsocSubscriptionPayload) => {
      const response = await ChessRestClient.post(
        'subscription/v1/csoc/resume-subscription',
        payload,
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return {
    ...mutation,
  };
}
